"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onJWTAuthSignout = exports.setJWTToken = exports.loadJWTUser = exports.onJwtSignIn = exports.onJwtUserSignUp = void 0;
var jwt_api_1 = require("../../@crema/services/auth/jwt-auth/jwt-api");
var Common_1 = require("./Common");
var AppEnums_1 = require("../../shared/constants/AppEnums");
var AppConst_1 = require("../../shared/constants/AppConst");
var Auth_actions_1 = require("../../types/actions/Auth.actions");
var onJwtUserSignUp = function (body) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, Common_1.fetchStart)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, jwt_api_1.default.post('users', body)];
                case 2:
                    res = _a.sent();
                    localStorage.setItem('token', res.data.token);
                    dispatch((0, exports.setJWTToken)(res.data.token));
                    return [4 /*yield*/, (0, exports.loadJWTUser)(dispatch)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    console.log('error!!!!', err_1.response.data.error);
                    dispatch((0, Common_1.fetchError)(err_1.response.data.error));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.onJwtUserSignUp = onJwtUserSignUp;
var onJwtSignIn = function (body) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, Common_1.fetchStart)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, jwt_api_1.default.post('auth', body)];
                case 2:
                    res = _a.sent();
                    localStorage.setItem('token', res.data.token);
                    dispatch((0, exports.setJWTToken)(res.data.token));
                    return [4 /*yield*/, (0, exports.loadJWTUser)(dispatch)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_2 = _a.sent();
                    console.log('error!!!!', err_2.response.data.error);
                    dispatch((0, Common_1.fetchError)(err_2.response.data.error));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.onJwtSignIn = onJwtSignIn;
var loadJWTUser = function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch((0, Common_1.fetchStart)());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, jwt_api_1.default.get('/auth')];
            case 2:
                res = _a.sent();
                dispatch((0, Common_1.fetchSuccess)());
                console.log('res.data', res.data);
                dispatch({
                    type: Auth_actions_1.UPDATE_AUTH_USER,
                    payload: getUserObject(res.data),
                });
                return [3 /*break*/, 4];
            case 3:
                err_3 = _a.sent();
                console.log('error!!!!', err_3.response.error);
                dispatch((0, Common_1.fetchError)(err_3.response.error));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.loadJWTUser = loadJWTUser;
var setJWTToken = function (token) { return ({
    type: Auth_actions_1.SET_AUTH_TOKEN,
    payload: token,
}); };
exports.setJWTToken = setJWTToken;
var getUserObject = function (authUser) {
    return {
        authType: AppEnums_1.AuthType.JWT_AUTH,
        displayName: authUser.name,
        email: authUser.email,
        role: AppConst_1.defaultUser.role,
        token: authUser._id,
        uid: authUser._id,
        photoURL: authUser.avatar,
    };
};
var onJWTAuthSignout = function () {
    return function (dispatch) {
        dispatch((0, Common_1.fetchSuccess)());
        setTimeout(function () {
            dispatch({ type: Auth_actions_1.SIGNOUT_AUTH_SUCCESS });
            dispatch((0, Common_1.fetchSuccess)());
            localStorage.removeItem('token');
        }, 500);
    };
};
exports.onJWTAuthSignout = onJWTAuthSignout;
//# sourceMappingURL=JWTAuth.js.map